export type Expertise = {
  num: string;
  name: string;
  slug: string;
  short: string;
  copy: string[];
  caps: string[];
  img: string;
  alt: string;
};

const u = (id: string, w = 1600) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMAGES = {
  hero: u("photo-1558620013-a08999547a36", 2400),
  intro: u("photo-1574155088851-0c770818ba40", 1200),
  realisations: u("photo-1576514129883-2f1d47a65da6", 1600),
  about: u("photo-1610614961503-7beb611d1d3f", 1600),
  aboutAccent: u("photo-1515175192010-cf3250992719", 1200),
  architectural: u("photo-1758413354881-3499004c0b8d", 1200),
};

export const EXPERTISES: Expertise[] = [
  {
    num: "01",
    name: "Sonorisation",
    slug: "sonorisation",
    short: "Systèmes de diffusion adaptés à chaque lieu.",
    copy: [
      "Des solutions de sonorisation professionnelles adaptées aux exigences de chaque événement.",
      "Diffusion sonore, systèmes de sonorisation, microphones, régie audio et installations techniques : nous concevons et déployons des dispositifs cohérents avec les caractéristiques des lieux et les besoins de chaque production.",
    ],
    caps: ["Diffusion sonore", "Systèmes de sonorisation", "Microphones", "Régie audio"],
    img: u("photo-1483000805330-4eaf0a0d82da"),
    alt: "Console de mixage audio lors d'un événement — sonorisation professionnelle SONOCO EVENTS",
  },
  {
    num: "02",
    name: "Éclairage",
    slug: "eclairage",
    short: "Scénique, architectural, événementiel.",
    copy: [
      "L'éclairage structure les espaces, révèle les architectures et accompagne les temps forts de vos événements.",
      "Éclairage scénique, architectural et événementiel : nous développons des solutions lumineuses alliant précision technique et créativité.",
    ],
    caps: ["Éclairage scénique", "Éclairage architectural", "Éclairage événementiel"],
    img: u("photo-1670028514318-0ac718c0590d"),
    alt: "Scène éclairée en rouge face au public — éclairage événementiel SONOCO EVENTS",
  },
  {
    num: "03",
    name: "Régie technique",
    slug: "regie-technique",
    short: "Anticipation, coordination, exécution.",
    copy: [
      "Nous accompagnons la préparation, la coordination et l'exploitation technique des événements.",
      "Notre approche repose sur l'anticipation, l'organisation et la maîtrise des contraintes opérationnelles.",
    ],
    caps: ["Préparation technique", "Coordination", "Exploitation & suivi"],
    img: u("photo-1504904126298-3fde501c9b31"),
    alt: "Régisseur technique à la console — régie technique événementielle SONOCO EVENTS",
  },
  {
    num: "04",
    name: "Infrastructures scéniques",
    slug: "infrastructures-sceniques",
    short: "Structures, électricité, installations.",
    copy: [
      "Structures scéniques, distribution électrique et installations techniques : nous mettons en œuvre les infrastructures nécessaires aux productions événementielles professionnelles.",
    ],
    caps: ["Structures scéniques", "Distribution électrique", "Installations techniques"],
    img: u("photo-1670420421505-804c23232098"),
    alt: "Structures truss et équipements scéniques en cours d'installation — infrastructures scéniques SONOCO EVENTS",
  },
  {
    num: "05",
    name: "Scénographie & fabrication",
    slug: "scenographie-fabrication",
    short: "Conception et fabrication sur mesure.",
    copy: [
      "Nous imaginons et réalisons des éléments de scénographie et des installations personnalisées.",
      "De la conception à la fabrication, nous développons des solutions adaptées aux contraintes techniques, esthétiques et opérationnelles de chaque projet.",
    ],
    caps: ["Conception", "Fabrication", "Installations personnalisées"],
    img: u("photo-1607872863060-fb85bd7229c4"),
    alt: "Installation scénographique personnalisée sur scène — scénographie SONOCO EVENTS",
  },
];

export const PILLARS = [
  { num: "01", name: "Précision", desc: "Des solutions dimensionnées au plus juste, sans improvisation." },
  { num: "02", name: "Créativité", desc: "Des partis pris techniques au service des idées et des lieux." },
  { num: "03", name: "Expertise", desc: "La maîtrise des métiers du son, de la lumière et de la scène." },
  { num: "04", name: "Exécution", desc: "De l'étude initiale au démontage, une exécution maîtrisée." },
];

export const PROJECT_CATEGORIES = [
  "Événementiel corporate",
  "Éclairage architectural",
  "Production scénique",
  "Installations techniques",
  "Scénographie",
];
